<template>
  <v-app-bar app dark color="primary">
    <v-app-bar-nav-icon
      @click.stop="$emit('toggle-sidebar')"
    ></v-app-bar-nav-icon>

    <v-toolbar-title>
      {{ title }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <span>{{ userName }}</span>

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list min-width="180">
        <v-list-item link to="/profile">
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-content>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <template
      v-slot:extension
      v-if="$route.matched.some(record => record.meta.navbarTabs)"
    >
      <v-tabs
        v-if="$route.matched.some(record => record.name === 'vessel')"
        align-with-title
        background-color="transparent"
      >
        <v-tab :to="{ name: 'vesselDetails' }" replace>Details</v-tab>
        <v-tab :to="{ name: 'vesselTrials' }" replace>Trials</v-tab>
        <v-tab :to="{ name: 'vesselMachines' }" replace>Machines</v-tab>
        <v-tab :to="{ name: 'vesselCrew' }" replace>Crew</v-tab>
      </v-tabs>

      <v-tabs
        v-if="$route.matched.some(record => record.name === 'vesselTrial')"
        align-with-title
        background-color="transparent"
      >
        <v-tab :to="{ name: 'vesselTrialDetails' }" replace>Details</v-tab>
        <v-tab :to="{ name: 'vesselTrialTests' }" replace>Tests</v-tab>
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  name: 'TheNavbar',
  computed: {
    title() {
      return this.$store.state.title
        ? this.$store.state.title
        : this.$route.meta.title
    },
    userName() {
      return this.$store.state.user.name
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped></style>
